import React from 'react';
import {Users, Permissions, Web, Cloud} from '../../../components/svgs/software';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {colors} from '../../../style/constants.js';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    textAlign: 'center',
    background: colors.LIGHT_GREY,
    marginTop: -60,
    color: colors.ATT_BLUE,
    '& h2': {
      marginBottom: 60,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 30,
      },
    }
  },
  icon: {
    background: colors.TURQUOISE,
    width: 120,
    height: 120,
    boxSizing: 'border-box',
    padding: 30,
    borderRadius: '50%',
    marginBottom: 30,
    boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.25)',
    [theme.breakpoints.down('xs')]: {
      width: 75,
      height: 75,
      padding: 15,
      margin: '0 0 15px 0',
    },
    '& svg': {
      filter: 'brightness(0) invert(1)',
      width: '100%',
      height: '100%',
    }
  }
}));

const General = (props) => {

  const renderGeneralsFunctions = () => {
    return props.items.map((item, index) => {
      const renderIcon = () => {
        if (item.node.icon === "users") {
          return <Users />
        }
        if (item.node.icon === "permissions") {
          return <Permissions />
        }
        if (item.node.icon === "web") {
          return <Web />
        }
        if (item.node.icon === "cloud") {
          return <Cloud />
        }
      }
      return (
        <Grid item xs={6} md={3} key={index}>
          <Grid container justifyContent='center'>
            <Grid className={classes.icon} container alignItems='center' justifyContent='center'>{renderIcon()}</Grid>
          </Grid>
          <Grid><h3>{item.node.name}</h3></Grid>
        </Grid>
      );
    });
  }

  const classes = useStyles();
  return (
    <section id="software" className={classes.wrapper + " clipped"}>
      <Container>
      <h2>{props.lang === 'en-CA' ? 'A simple, intuitive, and human software offering:' : 'Un logiciel simple, intuitif et humain offrant:'}</h2>
      <Grid container spacing={4}>
        {renderGeneralsFunctions()}
      </Grid>
      </Container>
    </section>
  );
}

export default General;